import { createContext } from 'react';

import type { AgentAuthorityResponse } from '@/lib/heyapi/types.gen';

// TODO: migrate AgentAuthorityContext to a new AgentAuthorityStore using zustand instead of context
export const AgentAuthorityContext = createContext<{
  responsive?: boolean;
  editMode: boolean;
  // Raw permission-only edit gate. `editMode` is the combined gate that
  // also locks during a Change Expiration Date midterm — use this when a
  // surface must stay editable during that lock (e.g. Pricing Preview's
  // Reason for Change input is required to commit the CED).
  permissionsAllowEdit?: boolean;
  setEditMode?: (value: boolean) => void;
  agentAuthority?: AgentAuthorityResponse;
  refetchAgentAuthority?: () => void;
}>({
  responsive: undefined,
  editMode: false,
  permissionsAllowEdit: false,
  setEditMode: () => {},
  agentAuthority: undefined,
  refetchAgentAuthority: () => {},
});
